import SgVisuallyHidden from './src/visual-hidden.vue'
import type { App } from 'vue'

SgVisuallyHidden.install = (app: App): void => {
  app.component(SgVisuallyHidden.name, SgVisuallyHidden)
}

export { SgVisuallyHidden }

export default SgVisuallyHidden
